import useEventData from "../../../custom_hooks/useEventData";
import React, { useMemo } from "react";
import { categorizeEvents } from "../../../utility/event.utils";
import EventsCardView from "./events-card.view";
import dayjs from "dayjs";
import Locale from "../../../core/locale/locale";

const EventsCard = () => {

    const startDate = dayjs().format(Locale.dateFormat);
    const endDate = dayjs().add(3, "month").format(Locale.dateFormat);

    const {data: {events, trainingEvents}, isLoading} = useEventData({
        startDate: startDate,
        endDate: endDate,
    });

    const mappedData = useMemo(() => {
        return {
            customEventData: categorizeEvents(events || []),
            trainingEventData: categorizeEvents(trainingEvents || [])
        }
    }, [events, trainingEvents]);

    const eventsData = useMemo(() => {
        const hasTodayEvents =
            mappedData.customEventData.today.length > 0 ||
            mappedData.trainingEventData.today.length > 0;

        const trainingData = hasTodayEvents ? mappedData.trainingEventData.today : mappedData.trainingEventData.upcoming;
        const customEventsData = hasTodayEvents ? mappedData.customEventData.today : mappedData.customEventData.upcoming;

        const mergedEventsData = [...trainingData, ...customEventsData].sort((a, b) => (
            dayjs(a.startDate).diff(dayjs(b.startDate))
        ))

        return {
            type: hasTodayEvents ? "today" : "upcoming",
            data: mergedEventsData
        };
    }, [mappedData]);


    return (
        <EventsCardView eventsData={eventsData} loading={isLoading}/>
    )
}

export default EventsCard;
